import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  display: flex;
  margin: 15px 0;
  flex-wrap: wrap;
  grid-column-gap: 12px;
  grid-row-gap: 10px;
  > div {
    padding: 7px 12px;
    font-weight: bold;
    border-radius: 20px;
    transition: all ease-out 0.25s;
    border: 1px solid transparent;
    box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px ${COLORS.WHITE};
    background: ${COLORS.WHITE};
    cursor: pointer;
    :hover {
      border: 1px solid #ddd;
    }
    :last-child {
      margin: 0;
    }
    span {
      border: 1px solid ${COLORS.BLACK};
      font-size: 11px;
      font-weight: 600;
      text-shadow: none;
      padding: 4px 6px;
      margin-left: 5px;
      border-radius: 20px;
      background: ${COLORS.WHITE};
      color: ${COLORS.BLACK};
    }
    &.selected {
      background: ${COLORS.BLACK};
      color: ${COLORS.WHITE};
    }
  }
`;

export { Container };
